import { Button } from 'reactstrap';
import { SmartMatchHint } from './useSmartMatchHints';
import { NumberScale } from '@g17eco/types/units';
import { SMART_MATCH } from '@constants/terminology';
import { BasicAlert } from '@g17eco/molecules/alert';

interface SmartMatchFieldHintProps {
  hint: SmartMatchHint;
  onUseValue: () => void;
  isApplied: boolean;
}

const formatValue = (hint: SmartMatchHint): string => {
  const numberScale = hint.numberScale === NumberScale.Single ? '' : hint.numberScale;
  const parts = [String(hint.value), numberScale, hint.unit].filter(Boolean);
  return parts.join(' ');
};

export const SmartMatchFieldHint = ({ hint, onUseValue, isApplied }: SmartMatchFieldHintProps) => {
  const displayValue = formatValue(hint);
  const metricLabel = hint.metricName ? `${hint.metricName}: ${displayValue}` : displayValue;

  return (
    <BasicAlert type='success' className='d-flex align-items-center justify-content-center gap-2 mt-1 mb-2 py-2 px-3'>
      <span>
        <strong>{SMART_MATCH.CAPITALIZED_SINGULAR} from {hint.providerName}</strong>
        {` \u2014 ${metricLabel}`}
      </span>
      {isApplied ? (
        <span className='text-nowrap'>
          <i className='fa-solid fa-check mr-1' />
          Value applied
        </span>
      ) : (
        <Button
          size='sm'
          outline
          color='success'
          className='text-nowrap rounded'
          onClick={onUseValue}
        >
          Use value
        </Button>
      )}
    </BasicAlert>
  );
};
